import $ from "jquery";
import {gsap} from "gsap";
import {debounce, throttle} from "lodash/function";

const $marquees = $(".customer-marquee")
let window_width = $( window ).width();
let arrayTweenMarquee = [];

const init = () => {
    $marquees.each((index, el) => {
        const $img_logo = $(el).find('img');
        $img_logo.one("load", function() {
            resize_windows()
        }).each(function() {
            if(this.complete) {
                $(this).trigger('load');
            }
        });
    });

    $(window).on('resize', throttle(resize_windows, 150));
    resize_windows();
}

const resize_windows = () => {
    // on arrate toutes les tweens
    // console.log("resize_windows");
    arrayTweenMarquee.forEach((item, index) => {
        // console.log(`index = ${index}`);
        const $ul = $(`#${item.marquee_id}`);
        $ul.off();
        $ul.children("li.is-clone").remove();
        item.tween.pause(0);
        item.tween.kill();
        arrayTweenMarquee = [];
    })

    window_width = $( window ).width();

    $marquees.each((index, el) => {
        const $ul = $(el).children("ul.marquee-content");
        const largeur_all_li = calculate_total_width($ul);
        if(largeur_all_li > window_width){
            duplicate_and_animate_marquee($ul, largeur_all_li, $ul.attr('id'))
        }
    });
}


const calculate_total_width = ($ul) => {
    let total_width = 0;
    const $all_li = $ul.children('li')
    $all_li.each((index, el) => {
        total_width += $(el).outerWidth(true);
    })
    return total_width;
}

const duplicate_and_animate_marquee = ($ul, largeur_all_li, marquee_id) => {
    $ul.children("li").clone().addClass('is-clone').appendTo($ul);
    const dest =  -1 * largeur_all_li -70;
    const speed = 18/760; // (760px en 18 secondes)
    const duration = -1 * dest * speed;
    const tween = gsap.to($ul.children("li"), {x:dest, ease:"none", repeat:-1, duration:duration, delay:.5})
    $ul.on('mouseenter', (e) => mouseenter_marques_handler(e))
        .on('mouseleave', (e) => mouseleave_marques_handler(e))
    arrayTweenMarquee.push({marquee_id,tween});
}

const mouseenter_marques_handler = (e) => {
    const tween = getTheTweenFromEvent(e);
    tween.pause();
}


const mouseleave_marques_handler = (e) => {
    const tween = getTheTweenFromEvent(e);
    tween.resume();
}

const getTheTweenFromEvent = (e) => {
    const $ul = $(e.currentTarget),
        ulId = $ul.attr('id');
    const item = arrayTweenMarquee.find(function (item) {
        return item.marquee_id === ulId;
    });
    return item.tween;
}

const customers_marquee = () => {
    if($marquees.length){
        init();
    }
}


export {customers_marquee}